export default __webpack_public_path__ + "static/media/magic.5ac6975c.svg";